// extracted by mini-css-extract-plugin
export default {"container":"folder_item-module__container--Sh-Mi","link":"folder_item-module__link--tGx3p","close":"folder_item-module__close--bvL-o","icon":"folder_item-module__icon--3MJ1y"};